/* global axios */
import ApiClient from '../ApiClient';

class ConversationFieldValuesAPI extends ApiClient {
  constructor() {
    super('omni/conversation_field_values', { accountScoped: true });
  }

  getByConversation(conversationId, botId) {
    return axios.get(this.url, {
      params: {
        conversation_id: conversationId,
        agent_bot_id: botId,
      },
    });
  }
}

export default new ConversationFieldValuesAPI();
